export default "__VITE_ASSET__0a9c17f5__"